var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 8.66634C6.03486 8.66634 6.33333 8.36786 6.33333 7.99967C6.33333 7.63148 6.03486 7.33301 5.66667 7.33301C5.29848 7.33301 5 7.63148 5 7.99967C5 8.36786 5.29848 8.66634 5.66667 8.66634Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 8.66634C10.7014 8.66634 10.9998 8.36786 10.9998 7.99967C10.9998 7.63148 10.7014 7.33301 10.3332 7.33301C9.96498 7.33301 9.6665 7.63148 9.6665 7.99967C9.6665 8.36786 9.96498 8.66634 10.3332 8.66634Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 4.00033C6.03486 4.00033 6.33333 3.70185 6.33333 3.33366C6.33333 2.96547 6.03486 2.66699 5.66667 2.66699C5.29848 2.66699 5 2.96547 5 3.33366C5 3.70185 5.29848 4.00033 5.66667 4.00033Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 4.00033C10.7014 4.00033 10.9998 3.70185 10.9998 3.33366C10.9998 2.96547 10.7014 2.66699 10.3332 2.66699C9.96498 2.66699 9.6665 2.96547 9.6665 3.33366C9.6665 3.70185 9.96498 4.00033 10.3332 4.00033Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 13.3333C6.03486 13.3333 6.33333 13.0349 6.33333 12.6667C6.33333 12.2985 6.03486 12 5.66667 12C5.29848 12 5 12.2985 5 12.6667C5 13.0349 5.29848 13.3333 5.66667 13.3333Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 13.3333C10.7014 13.3333 10.9998 13.0349 10.9998 12.6667C10.9998 12.2985 10.7014 12 10.3332 12C9.96498 12 9.6665 12.2985 9.6665 12.6667C9.6665 13.0349 9.96498 13.3333 10.3332 13.3333Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.9b53c08ca55b6e297896d51013501946.svg";
export { ForwardRef as ReactComponent };